export const theme = [
    {
        label: '亮色',
        value: 'light',
    },
    {
        label: '暗色',
        value: 'dark',
    },
    {
        label: '灰色',
        value: 'grey'
    },
    {
        label: '蓝色',
        value: 'blue',
    },
    {
        label: '青色',
        value: 'cyan'
    },
    {
        label: '绿色',
        value: 'green'
    },
    {
        label: '紫色',
        value: 'purple'
    },
    {
        label: '红色',
        value: 'red'
    },
    {
        label: '粉色',
        value: 'pink'
    },
];

export default theme;
